import React from "react";
import { Modal } from "react-bootstrap";
import { motion, useReducedMotion } from "framer-motion";
import { BsEnvelope, BsTwitter, BsInstagram, BsWhatsapp } from "react-icons/bs";


const items = [
  {
    key: "email",
    label: "Email",
    sub: "admin@qwikchow.com",
    href: "mailto:admin@qwikchow.com",
    Icon: BsEnvelope,
  },
  {
    key: "twitter",
    label: "Twitter",
    sub: "@qwikchow",
    href: "https://twitter.com/qwikchow",
    Icon: BsTwitter,
  },
  {
    key: "instagram",
    label: "Instagram",
    sub: "@qwik_chow",
    href: "https://instagram.com/qwik_chow",
    Icon: BsInstagram,
  },
  {
    key: "whatsapp",
    label: "WhatsApp",
    sub: "Chat with us",
    href: "https://wa.me/2349110053549?text=Hello%20there!",
    Icon: BsWhatsapp,
  },
];

const ContactModal = ({ show, handleClose }) => {
  const reduceMotion = useReducedMotion();

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="qcC-dialog"
      contentClassName="qcC-content"
      backdropClassName="qcC-backdrop"
    >
      {/* Header */}
      <div className="qcC-header">
        <div className="qcC-titleWrap">
          <div className="qcC-title">Contact</div>
          <div className="qcC-sub">Pick any channel — we reply fast.</div>
        </div>

        <button className="qcC-x" onClick={handleClose} aria-label="Close">
          ✕
        </button>
      </div>

      {/* Body */}
      <div className="qcC-body">
        <motion.div
          initial={reduceMotion ? false : { opacity: 0, y: 10 }}
          animate={show && !reduceMotion ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.22, ease: "easeOut" }}
          className="qcC-list"
        >
          {items.map(({ key, label, sub, href, Icon }) => (
            <a
              key={key}
              className="qcC-item"
              href={href}
              target={href.startsWith("http") ? "_blank" : undefined}
              rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
              onClick={() => {
                // optional: close after click for external links
                // handleClose();
              }}
            >
              <span className="qcC-icon">
                <Icon />
              </span>

              <span className="qcC-text">
                <span className="qcC-label">{label}</span>
                <span className="qcC-meta">{sub}</span>
              </span>

              <span className="qcC-arrow" aria-hidden="true">
                →
              </span>
            </a>
          ))}
        </motion.div>

        <div className="qcC-hint">
          <span className="qcC-hintDot" aria-hidden="true" />
          Only support & feedback — no spam.
        </div>
      </div>

      {/* Footer */}
      <div className="qcC-footer">
        <motion.button
          type="button"
          className="qcC-close"
          onClick={handleClose}
          whileHover={reduceMotion ? {} : { y: -1, scale: 1.01 }}
          whileTap={reduceMotion ? {} : { scale: 0.98 }}
          transition={{ duration: 0.14 }}
        >
          Close
        </motion.button>
      </div>
    </Modal>
  );
};

export default ContactModal;
